<template>
  <el-drawer
    size="650px"
    :withHeader="false"
    append-to-body
    v-model="drawer"
  >
    <el-button style="opacity: 0" />
    <div class="drawer">
      <el-scrollbar style="height: calc(100% - 70px)">
        <el-form class="filter-form" label-position="top">
          <el-row :gutter="20">
            <el-col :span="12" 
            v-for="(item) in query"
            :key="item.title">
            <el-form-item
              :label="item.name"
            >
                <el-select
                  v-model="item.value"
                  style="width: 100%;"
                  :placeholder="'选择' + item.name"
                  multiple
                  collapse-tags
                  v-if="item.type == 'status'"
                >
                  <el-option label="待审批" value="0"></el-option>
                  <el-option label="已通过" value="1"></el-option>
                  <el-option label="未通过" value="2"></el-option>
                  <el-option label="已撤回" value="3"></el-option>
                  <el-option v-for="status in customStatus" :key="status.value" :value="status" :label="status.value" />
                </el-select>
                <el-date-picker
                  v-model="item.value"
                  class="time-managementList"
                  style="width: 100%;"
                  type="daterange"
                  range-separator="至"
                  format="YYYY-MM-DD"
                  value-format="YYYY-MM-DD"
                  start-placeholder="申请时间开始"
                  end-placeholder="申请时间结束"
                  v-if="item.type == 'timeof'"
                ></el-date-picker>
                <el-select
                  v-model="item.value"
                  style="width: 100%;"
                  :placeholder="'选择' + item.name"
                  multiple
                  collapse-tags
                  v-if="item.type == 'radio' || item.type == 'checkbox'"
                >
                  <el-option
                    v-for="(sels, idx) in item.sels || []"
                    :key="idx"
                    :label="sels.label || sels"
                    :value="sels.value || sels"
                  ></el-option>
                </el-select>
                <el-date-picker
                  v-model="item.value"
                  style="width: 100%;"
                  :type="isMonthFormat(item) ? 'monthrange' : 'daterange'"
                  range-separator="至"
                  class="time-managementList"
                  :start-placeholder="item.name + '开始'"
                  :format="getFormat(item)"
                  :value-format="getFormat(item)"
                  :end-placeholder="item.name + '结束'"
                  v-if="item.type == 'date' || item.type === 'dates'"
                ></el-date-picker>
                <div class="filter-number" v-if="item.type == 'number'">
                  <el-select
                    v-model="item.value"
                    :placeholder="'选择' + item.name"
                  >
                    <el-option label="大于等于" value="大于等于"></el-option>
                    <el-option label="小于等于" value="小于等于"></el-option>
                    <el-option label="两者之间" value="两者之间"></el-option>
                  </el-select>
                  <el-input-number
                    v-model="item.min"
                    :controls="false"
                  ></el-input-number>
                  <el-input-number
                    v-model="item.max"
                    v-if="item.value == '两者之间'"
                    :controls="false"
                  ></el-input-number>
                </div>
                <el-input v-if="item.type == 'text'" v-model="item.value" placeholder="请输入内容">
                </el-input>
            </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-scrollbar>
      <div class="filter-footer">
        <el-button size="small" @click="resetQuery">重置</el-button>
        <el-button size="small" @click="drawer = false">取消</el-button>
        <el-button size="small" type="primary" @click="searchBtn"
          >筛选</el-button
        >
      </div>
    </div>
  </el-drawer>
</template>

<script>
import { getdefinedstatus } from '@/port/schoolInstrument/appConfig.js'
  export default {
    name: "transactionFilter",
    props: {
      isFilter: Boolean,
      condition: Array,
      approvalId:{
        type: [String, Number]
      }
    },
    data () {
      return {
        drawer: false,
        query: [], //搜索列表数据
        queryVal: null,
        customStatus: []
      }
    },
    watch: {
      isFilter: {
        immediate: true,
        handler (val) {
          if (val) {
            this.query = JSON.parse(JSON.stringify(this.condition))
            this.getCustomStatus()
            this.drawer = true
          }
        }
      },
      drawer: {
        immediate: true,
        handler (val) {
          if (!val) this.$emit('update:isFilter', false)
        }
      }
    },
    methods: {
      async getCustomStatus(){
        // 获取自定义状态值
        const res = await getdefinedstatus({approvalId: this.approvalId}) 
        if (res.code === 0) {
          this.customStatus = res.data
        }
      },
      // 日期控件选择的格式
      getFormat (item) {
        if (item.type === 'date') {
          // 确保 item.match 存在且是字符串
          const matchValue = item.match || ''
          return String(matchValue).toUpperCase()
        }
        return 'YYYY-MM-DD'
      },
      // 判断是否为月份格式
      isMonthFormat (item) {
        const matchFormat = String(item.match || '').toUpperCase()
        return matchFormat === 'YYYY-MM'
      },
      // 重置筛选
      resetQuery () {
        const query = [...this.query]
        query.forEach(val => {
          if (val.type === 'timeof' || val.type === 'date') {
            delete val.value
          } else {
            val.value = null
          }
        })
        this.query = query
      },
      searchBtn () {
        let query = {};
        this.query.forEach(e => {
          if (e.value && e.value != '' && e.value.length > 0) {
            if (e.type == 'number') {
              var value = []
              if (e.value == '小于等于') {
                value = ['', e.min]
              } else if (e.value == '大于等于') {
                value = [e.min, '']
              } else {
                value = [e.min, e.max]
              }
              query[e.title + '_' + e.type] = value
            } else if (e.type == 'text') {
              const value = [e.value]
              query[e.title + '_' + e.type] = value
            } else if (e.type === 'status') {
              const customStatus = e.value.filter(c => typeof c === 'object' && c !== null).map(c=>({ value:c.step, status: c.status }))
              const defaultStatus = e.value.filter(c => typeof c !== 'object')
              if (defaultStatus.length !== 0) {
                query[e.title + '_' + e.type] = defaultStatus
              }
              query.step = customStatus
            } else if (e.type === 'date' || e.type === 'dates') {
              const matchFormat = String(e.match || '').toUpperCase()
              const isMonthFormat = matchFormat === 'YYYY-MM'
              
              const convertedValue = e.value.map((date, index) => {
                if (isMonthFormat && typeof date === 'string' && date.length === 7) {
                  if (index === 0) {
                    return date + '-01'
                  } else {
                    const [year, month] = date.split('-')
                    const nextMonth = new Date(year, parseInt(month), 0)
                    return `${year}-${String(parseInt(month)).padStart(2, '0')}-${String(nextMonth.getDate()).padStart(2, '0')}`
                  }
                }
                return date
              })
              query[e.title + '_' + e.type] = convertedValue
            } else {
              query[e.title + '_' + e.type] = e.value
            }
          }
        })
        this.$emit('update:condition', this.query)
        this.$emit('goFilter', query)
        this.drawer = false
      },
    }
  }
</script>

<style scoped lang="scss">
::v-deep :focus {
  outline: 0;
}
::v-deep .el-form-item__label {
  line-height: 20px;
}
::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
  overflow-y: scroll;
}
::v-deep .el-date-editor .el-range-input {
  text-align: left;
}
.drawer {
  position: absolute;
  top: 20px;
  right: 0;
  width: 100%;
  height: calc(100% - 20px);
}
.filter-form {
  padding: 0 30px 0 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .filter-number {
    display: flex;
    ::v-deep .el-input-number {
      width: 30%;
      margin-left: 4px;
    }
  }
  ::v-deep .el-form-item__label {
    color: #333;
    font-weight: 700;
  }
}
.filter-footer {
  text-align: right;
  padding-right: 19px;
  position: absolute;
  bottom: 0;
  line-height: 57px;
  border-top: 1px solid #d8d8d8;
  width: calc(100% - 19px);
  background: #fff;
}
</style>
